import {JqlApi} from "./mdk/jql-api.js";
import {JqlSchema, TextColumn, NumberColumn, DateColumn, Dropdown} from "./mdk/jql-schema.js";
import {http} from "@/mdk/auth-api";
import area from "@/views/pages/maps/address";
import confirmDatePlugin from "flatpickr/dist/plugins/confirmDate/confirmDate";
import {isDisabled} from "bootstrap/js/src/util";

const required = (v, entity) => {
    return (v != null && v != '') ? null : "필수 항목입니다"
}

const haveRoles = (v, entity) => {
    console.log(v, entity)
    return v.includes(',') ? null : '권한은 쉼표(,)로 구분되어야 합니다.'
}

const onlyNum = (v, entity) => {
    return (!isNaN(parseFloat(v, 10))) ? null : '숫자만 입력 가능합니다.'
}

const mapAddressSchema = new JqlSchema([
    new Dropdown('city', '시/도', Object.keys(area) ),
    new Dropdown('town', '시/군/구', []),
    new TextColumn('placeName', '충전소'),
    new Dropdown('station', '충전소', [])
]);

// @TODO 주석처리된 컬럼 -- DB에서 확인할 수 없음.
// 충전기 상태 진단 > 충전소 정보관리 탭
const placeSchema = new JqlSchema([
    new TextColumn('placeId', '충전소ID'),
    new TextColumn('placeName', '충전소명'),
    new TextColumn('address', '주소'),
    new TextColumn('type', '장소유형'),
    new TextColumn('opTime', '운영시간'),
    new TextColumn('useTarget', '사용대상'),
    new TextColumn('parkFee', '주차요금'),
    new NumberColumn('latitude', '위도'),
    new NumberColumn('longitude', '경도'),
    new TextColumn('csoId', '사업체명'),
    //
    // new TextColumn('admin', '관리자'),
    // new TextColumn('ownerType', '소유주 유형'),
    // new TextColumn('stationType', '충전소 유형'),
    // new TextColumn('operationType', '운용형태'),
    // new NumberColumn('chargerCount', '충전기수'),
    // new DateColumn('registerDate', '등록일'),
    // new Dropdown('status', '상태', ['운영중지', '사용중지', '정상']),
]);

// station과 charger join 걸기?
const chargerSchema = new JqlSchema([
    new TextColumn('placeInfo.placeId', '충전소 ID'),
    new TextColumn('placeInfo.placeName', '충전소명'),
    new TextColumn('placeInfo.address', '주소'),
    new TextColumn('csoEvseNum', '충전기 ID'),
    new Dropdown('connector', '커넥터', {
        cType1: '완속',
        cCCS1: '콤보',
        cG105: '차데모',
        's309-1P-32AA': 'AC3상'}),
    new Dropdown('speed', '충전 속도', {'완속': '완속', '급속': '급속'}),
    new Dropdown('capacity', '충전 용량', {7: '7kW', 50: '50kW', 100: '100kW'}),
    // new NumberColumn('connectorId', '커넥터 ID', ),
    new TextColumn('timestamp', '상태변경시간'),
    new Dropdown('connectorStatus', '충전기 상태', {
        Available: 'Available',
        Occupied : 'Occupied',
        Reserved: 'Reserved',
        Unavailable: 'Unavailable',
        Faulted: 'Faulted',
        Finishing: 'Finishing',
        Charging: 'Charging',
        Preparing: 'Preparing',
    }),
    new Dropdown('errorCode', '에러 코드', {}),
    new TextColumn('vendorId', '제조사 ID'),
    new TextColumn('vendorErrorCode', '제조사 에러')
]);
chargerSchema.join('placeInfo', placeSchema);

/*
chargingState: "Charging"
csId: "D88039EC48E0"
endTime: "2022-08-24T10:57:00.000+00:00"
evseInfo:
    capacity: 100
    connector: (2) ['cCCS1', 'cCCS2']
    csId: "D88039EC48E0"
    csoEvseNum: "4701"
    csoId: "KLE"
    evseCurrentStatus: {csId: 'D88039EC48E0', evseId: 1, csoId: 'KLE', connectorId: 1, timestamp: '2022-09-16T08:48:01.000+00:00', …}
    evseId: 1
    placeInfo: {placeId: '001371', placeName: '1인덕원 IT밸리', csoId: 'KLE', address: '경기 의왕시 이미로 40', type: '공동주택', …}
    speed: "급속"

latestChargingTime: "2022-08-24T10:56:00.000+00:00"
reservationId: 1
startTime: "2022-08-24T10:50:00.000+00:00"
stoppedReason: "SOCLimitReached"
transactionId: "689063"

transactionUserInfo:
    isMember: true
    isRoaming: false
    seq_user_id: 1
    transactionEvent: {eventId: 1}
    userId: "11511"
    userName: "이재석"
    userPhone: "01000000000"
 */

const transactionStateSchema = new JqlSchema([
    new TextColumn('transactionId', '충전 트랜잭션ID'),
    new TextColumn('evseInfo.csoId', '사업자ID'),
    new TextColumn('evseInfo.placeInfo.placeId', '충전소ID'),
    new TextColumn('evseInfo.placeInfo.placeName', '충전소명'),
    new TextColumn('csoEvseNum', '충전기ID'),
    new DateColumn('startTime', '충전시작', {
        dateFormat: "Y-m-d",
        mode: "single",
        allowInput: true
    }),
    new DateColumn('endTime', '충전종료', {
        dateFormat: "Y-m-d",
        mode: "single",
        allowInput: true
    }),
    new TextColumn('leadTime', '충전소요시간(분)'),
    // new TextColumn('userName', '이용자'),
    new TextColumn('userId', '회원번호'),
    // new TextColumn('userPhone', '전화번호'),
    new TextColumn('totEnergy', '충전량(kWh)'),
    new TextColumn('totCost', '결제금액(원)'),
    // new TextColumn('결제방법', '결제방법'),
    new Dropdown('stoppedReason', '충전종료사유', {
        DeAuthorized: 'DeAuthorized',
        EmergencyStop: 'EmergencyStop',
        EnergyLimitReached: 'EnergyLimitReached',
        EVDisconnected: 'EVDisconnected',
        GroundFault: 'GroundFault',
        ImmediateReset: 'ImmediateReset',
        Local: 'Local',
        LocalOutOfCredit: 'LocalOutOfCredit',
        MasterPass: 'MasterPass',
        Other: 'Other',
        OvercurrentFault: 'OvercurrentFault',
        PowerLoss: 'PowerLoss',
        PowerQuality: 'PowerQuality',
        Reboot: 'Reboot',
        Remote: 'Remote',
        SOCLimitReached: 'SOCLimitReached',
        StoppedByEV: 'StoppedByEV',
        TimeLimitReached: 'TimeLimitReached',
        Timeout: 'Timeout'
    }),
    // new TextColumn('log', '로그'),
]);

transactionStateSchema.join('evseInfo', chargerSchema).join('placeInfo', placeSchema);

// 충전기 이용현황 > Charger_Today.vue
const chargerTodayChartSchema = new JqlSchema([
    new TextColumn('hours', '시간'),
    new TextColumn('totalEnergy', '충전량'),
]);

const chargerTodayResultSchema = new JqlSchema([
    new TextColumn('totalEnergy', '충전량 (kWh)'),
    new TextColumn('totalCost', '충전금액 (원)'),
    new TextColumn('count', '이용빈도 (건)'),
]);

const chargerEvseListSchema = new JqlSchema([
    new TextColumn('placeName', '충전기명'),
    new TextColumn('evseNumber', 'evse'),
]);

const chargerEvseChartSchema = new JqlSchema([
    new TextColumn('hour', '시간'),
    new TextColumn('utilization', '이용률'),
]);

const chargerEvseResultSchema = new JqlSchema([
    new TextColumn('totalEnergy', '충전량'),
    new TextColumn('totalCost', '충전금액'),
    new TextColumn('utilization', '이용률'),
    new TextColumn('count', '이용빈도')
]);

const chargerEvseUserSchema = new JqlSchema([
    new TextColumn('lastCharging', '마지막 충전 시간'),
    new TextColumn('memCount', '회원 충전 횟수'),
    new TextColumn('memEnergy', '회원 충전량'),
    new TextColumn('nonMemCount', '비회원 충전 횟수'),
    new TextColumn('nonMemEnergy', '비회원 충전량'),
    new TextColumn('roamingCount', '로밍 회원 충전 횟수'),
    new TextColumn('roamingEnergy', '로밍 회원 충전량'),
]);

// 충전기 이용현황 > 금일 정보 api
class ChargerToday {
    constructor(url, schema) {
        this.baseUrl = url;
        this.schema = schema;
        this.columnInfos = schema.columns;
    }

    async requestToday() {
        const res = await http.get(this.baseUrl)

        return res.data;
    }

    async requestEvseList() {
        const res = await http.get(this.baseUrl)

        return res;
    }

    async requestEvseChart(placeName, evseNumber) {
        const res = await http.get(this.baseUrl+`?placeName=${placeName}&evseNumber=${evseNumber}`)

        return res;
    }

    async requestEvseResult(placeName, evseNumber) {
        const res = await http.get(this.baseUrl+`?placeName=${placeName}&evseNumber=${evseNumber}`)

        return res;
    }

    async requestUserResult(placeName, evseNumber) {
        const res = await http.get(this.baseUrl+`?placeName=${placeName}&evseNumber=${evseNumber}`)

        return res;
    }
}

const chargerStatusSchema = new JqlSchema([

]);


class ChargerStatus {
    constructor(url, schema) {
        this.baseUrl = url;
        this.schema = schema;
        this.columnInfos = schema.columns;
    }

    async requestStatus() {
        const res = await http.get(this.baseUrl)

        return res.data;
    }
}

const aptInfoSchema = new JqlSchema([
    new TextColumn('aptCode', '단지코드'),
    new TextColumn('name', '단지명'),
    new TextColumn('address', '주소'),
    new TextColumn('dongCount', '동수'),
    new TextColumn('houseCount', '세대수'),
    new TextColumn('approvalDate', '승일일'),
    new NumberColumn('electricCapacity', '수전용량'),
    new TextColumn('electricContractMethod', '계약방식')
]);

const aptPowerInfoSchema = new JqlSchema([
    new TextColumn('targetDate', '조회월'),
    new NumberColumn('avgUsePower', '단일적용전력'),
    new NumberColumn('avgUseComPower', '전월대비 증감값'),
    new NumberColumn('avgUseComRate', '전월대비 증감율'),
    new NumberColumn('peakPower', '피크전력'),
    new NumberColumn('peakComPower', '전월대비 증감값'),
    new NumberColumn('peakComRate', '전월대비 증감율')
]);
aptPowerInfoSchema.join('aptInfo', aptInfoSchema);

const batchSchema = new JqlSchema([
    new TextColumn('batchId', 'Batch ID'),
    new TextColumn('batchName', '배치명'),
    new TextColumn('batchDesc', '설명'),
    new Dropdown('batchType', '배치타입', {'batch':'BATCH', 'any':'ANY', 'period':'PERIOD'}),
    new TextColumn('executeTime', '배치시간'),
    new DateColumn('startTime', '시작시간', {
        dateFormat: "Y-m-d",
        mode: "single",
        allowInput: true,
        plugins: [new confirmDatePlugin({})]
    }),
    new DateColumn('endTime', '종료시간', {
        dateFormat: "Y-m-d",
        mode: "single",
        allowInput: true,
        plugins: [new confirmDatePlugin({})]
    }),
    new Dropdown('success', '실행 결과', {'true':'성공', 'false':'실패'})
]);

const feeSchema = new JqlSchema([
    new Dropdown('business', '사업자', ['A', 'B']),
    new Dropdown('date', '조회일'),
]);

const comPriceSchema = new JqlSchema([
    new TextColumn('name', '사업체명'),
    new TextColumn('light_ac_price.sf', '봄/가을'),
    new TextColumn('light_ac_price.sm', '여름'),
    new TextColumn('light_ac_price.wt', '겨울'),
    new TextColumn('heavy_ac_price_sf', '봄/가을'),
    new TextColumn('heavy_ac_price_sm', '여름'),
    new TextColumn('heavy_ac_price_wt', '겨울'),
    new TextColumn('max_ac_price_sf', '봄/가을'),
    new TextColumn('max_ac_price_sm', '여름'),
    new TextColumn('max_ac_price_wt', '겨울'),
    new TextColumn('dc_price', '급속 요금'),
    new NumberColumn('non_member_price', '비회원 요금'),
    new NumberColumn('roaming_price', '로밍 요금'),
]);

const comPriceSeasonSchema = new JqlSchema([
    new TextColumn('comCode', '충전사업자명', [required]),
    new TextColumn('priceType', '유형', [required]),
    new TextColumn('sfAcPrice.light', '경부하', [required, onlyNum]),
    new TextColumn('sfAcPrice.heavy', '중부하', [required, onlyNum]),
    new TextColumn('sfAcPrice.max', '최대부하', [required]),
    new TextColumn('smAcPrice.light', '경부하', [required]),
    new TextColumn('smAcPrice.heavy', '중부하', [required]),
    new TextColumn('smAcPrice.max', '최대부하', [required]),
    new TextColumn('wtAcPrice.light', '경부하', [required]),
    new TextColumn('wtAcPrice.heavy', '중부하', [required]),
    new TextColumn('wtAcPrice.max', '최대부하', [required]),
    new TextColumn('dcPrice.25~30', '25~30kW', ),
    new TextColumn('dcPrice.50', '50kW', [required]),
    new TextColumn('dcPrice.100', '100kW', [required]),
    new TextColumn('dcPrice.150', '150kW', [required]),
    new TextColumn('highPowerPrice', '350kW', ),
    new Dropdown('capacityPower', '설비용량', {'3':'3 kW', '7':'7 kW'}),
    new NumberColumn('nonMemberPrice', '비회원 요금', ),
    new TextColumn('roamingListPrice', '로밍 요금', ),
    new DateColumn('priceChangeDate', '요금변경일', {
        dateFormat: "Y-m-d",
        mode: "single",
        allowInput: true,
        plugins: [new confirmDatePlugin({})]
    }),
    new TextColumn('priceDesc', '안내 문구', ),
    new TextColumn('basicPrice', '기본요금', ),
    new TextColumn('etcAcPrice[3.5]', '3.5kW', ),
    new TextColumn('etcAcPrice.11', '11kW', ),
])

const userSchema = new JqlSchema([
    new TextColumn('id', '아이디'),
    new TextColumn('name', '이름'),
    new TextColumn('roles', '사용자 그룹', [required, haveRoles]),
    new TextColumn('email', '이메일')
]);

const noticeSchema = new JqlSchema([
    new TextColumn('title', '제목'),
    new TextColumn('contents', '본문'),
    new DateColumn('created', '등록일', {
        dateFormat: "Y-m-d",
        mode: "single",
        allowInput: true,
        plugins: [new confirmDatePlugin({})]
    }),
    new TextColumn('attachFile', '파일명')
]);

const expPriceSchema = new JqlSchema([
    new TextColumn('chargeAmount', '예상충전량', ),
    new TextColumn('memberFromToUnitPrice', '회원 단가', ),
    new TextColumn('nonMemberUnitPrice', '비회원 단가', ),
    new TextColumn('roamingPrice', '로밍요금', ),
    new TextColumn('memberExpPrice', '회원 결제금액', ),
    new TextColumn('nonMemberExpPrice', '비회원 결제금액', ),
])

// OCPP
const chargePointSchema = new JqlSchema([
    new TextColumn('chargeBoxId', 'Charge Box ID'),
    new TextColumn('chargeBoxName', 'Charge Box Name'),
    new TextColumn('chargePointVendor', 'Charge Point Vendor'),
    new TextColumn('chargePointModel', 'Charge Point Model'),
    new TextColumn('chargePointSerialNumber', 'Charge Point Serial Number'),
    new TextColumn('chargeBoxSerialNumber', 'Charge Box Serial Number'),
    new TextColumn('firmwareVersion', 'Firmware Version'),
    new TextColumn('iccid', 'ICCID'),
    new TextColumn('imsi', 'IMSI'),
    new TextColumn('meterType', 'Meter Type'),
    new TextColumn('meterSerialNumber', 'Meter Serial Number'),
    new TextColumn('heartbeatTimestamp', 'Heartbeat Timestamp'),
    new TextColumn('diagnosticsTimestmp', 'Diagnostics Timestamp'),
    new TextColumn('diagnosticsStatus', 'Diagnostics Status'),
    new TextColumn('fwUpdateTimestamp', 'Firmware Update Timestamp'),
    new TextColumn('fwUpdateStatus', 'Firmware Update Status'),
    new TextColumn('endpointAddress', 'Endpoint Address'),
    new DateColumn('created', 'Created', {
        dateFormat: "Y-m-d",
        mode: "single",
        allowInput: false,
        plugins: [new confirmDatePlugin({})]
    })
])

const idTagSchema = new JqlSchema([
    new TextColumn('id', 'ID'),
    new TextColumn('idTag', 'ID Tag'),
    new TextColumn('parentIdTag', 'Parent ID Tag'),
    new DateColumn('expiryDate', 'Expiry Date', {
        dateFormat: "Y-m-d",
        mode: "single",
        allowInput: false,
        plugins: [new confirmDatePlugin({})]
    }),
    new TextColumn('maxActiveTransactionCount', 'Max Active Transaction Count'),
    new TextColumn('activeTransactionCount', 'Active Transaction Count'),
    new TextColumn('inTransaction', 'In Transaction'),
    new TextColumn('isBlocked', 'Is Blocked'),
    new TextColumn('note', 'Note'),
    new DateColumn('created', 'Created', {
        dateFormat: "Y-m-d",
        mode: "single",
        allowInput: false,
        plugins: [new confirmDatePlugin({})]
    })
])

const profileSchedulePeriodSchema = new JqlSchema([
    new TextColumn('id', 'Id'),
    new TextColumn('chargingProfilePk', 'Profile Id'),
    new NumberColumn('startPeriodInSeconds', 'Start Period (sec)'),
    new NumberColumn('powerLimit', 'Power Limit'),
    new NumberColumn('numberPhases', 'Number Phases')
])

const profileSchema = new JqlSchema([
    new TextColumn('chargingProfilePk', 'Profile ID'),
    new TextColumn('profileName', 'Profile Name'),
    new NumberColumn('stackLevel', 'Stack Level'),
    new TextColumn('chargingProfilePurpose', 'Profile Purpose'),
    new TextColumn('chargingProfileKind', 'Profile Kind'),
    new TextColumn('recurrencyKind', 'Recurrency Kind'),
    new DateColumn('validFrom', 'Valid From', {
        dateFormat: "Y-m-d",
        mode: "single",
        allowInput: false,
        plugins: [new confirmDatePlugin({})]
    }),
    new DateColumn('validTo', 'Valid To', {
        dateFormat: "Y-m-d",
        mode: "single",
        allowInput: false,
        plugins: [new confirmDatePlugin({})]
    }),
    new NumberColumn('durationInSeconds', 'Duration (sec)'),
    new DateColumn('startSchedule', 'Start Schedule', {
        dateFormat: "Y-m-d",
        mode: "single",
        allowInput: false,
        plugins: [new confirmDatePlugin({})]
    }),
    new TextColumn('chargingRateUnit', 'Charging Rate Unit'),
    new TextColumn('minChargingRate', 'Min Charging Rate'),
    new TextColumn('description', 'Description')
])
profileSchema.join('chargingSchedulePeriod', profileSchedulePeriodSchema);

const logSchema = new JqlSchema([
    new TextColumn('id', 'ID'),
    new TextColumn('chargeBoxId', 'Charge Box Id'),
    new TextColumn('sessionId', 'Session Id'),
    new TextColumn('msg', 'Message'),
    new TextColumn('msgType', 'Message Type'),
    new DateColumn('created', 'Created', {
        dateFormat: "Y-m-d",
        mode: "single",
        allowInput: false,
        plugins: [new confirmDatePlugin({})]
    })
])

const connectorStatusSchema = new JqlSchema([
    new TextColumn('id', 'ID'),
    new TextColumn('chargeBoxId', 'Charge Box Id'),
    new TextColumn('connectorId', 'Connector Id'),
    new DateColumn('timestamp', 'Notification Time', {
        dateFormat: "Y-m-d",
        mode: "single",
        allowInput: false,
        plugins: [new confirmDatePlugin({})]
    }),
    new TextColumn('status', 'Status'),
    new TextColumn('errorCode', 'Error Code'),
    new TextColumn('errorInfo', 'Info'),
    new TextColumn('vendorId', 'Vendor Id'),
    new TextColumn('vendorErrorCode', 'Vendor Error Code')
])

const reservationSchema = new JqlSchema([
    new TextColumn('reservationId', 'Reservation Id'),
    new TextColumn('idTag', 'IdTag'),
    new TextColumn('chargeBoxId', 'Charge Box Id'),
    new TextColumn('connectorId', 'Connector Id'),
    new TextColumn('status', 'Status'),
    new TextColumn('transactionId', 'Transaction Id'),
    new DateColumn('startTimestamp', 'Start Timestamp', {
        dateFormat: "Y-m-d",
        mode: "single",
        allowInput: false,
        plugins: [new confirmDatePlugin({})]
    }),
    new DateColumn('expiryTimestamp', 'Expiry Timestamp', {
        dateFormat: "Y-m-d",
        mode: "single",
        allowInput: false,
        plugins: [new confirmDatePlugin({})]
    }),
    new DateColumn('created', 'Created', {
        dateFormat: "Y-m-d",
        mode: "single",
        allowInput: false,
        plugins: [new confirmDatePlugin({})]
    })
])

const stopTransactionSchema = new JqlSchema([
    new TextColumn('transactionId', 'Transaction Id'),
    new DateColumn('stopTimestamp', 'Stop Timestamp', {
        dateFormat: "Y-m-d",
        mode: "single",
        allowInput: false,
        plugins: [new confirmDatePlugin({})]
    }),
    new TextColumn('stopMeterValue', 'Stop Meter Value'),
    new TextColumn('stopReason', 'Stop Reason'),
    new DateColumn('eventTimestamp', 'Stop Created', {
        dateFormat: "Y-m-d",
        mode: "single",
        allowInput: false,
        plugins: [new confirmDatePlugin({})]
    })
])

const transactionSchema = new JqlSchema([
    new TextColumn('transactionId', 'Transaction Id'),
    new TextColumn('chargeBoxId', 'Charge Box Id'),
    new TextColumn('connectorId', 'Connector Id'),
    new TextColumn('idTag', 'IdTag'),
    new DateColumn('startTimestamp', 'Start Timestamp', {
        dateFormat: "Y-m-d",
        mode: "single",
        allowInput: false,
        plugins: [new confirmDatePlugin({})]
    }),
    new TextColumn('startMeterValue', 'Start Meter Value'),
    new TextColumn('reservationId', 'Reservation Id'),
    new DateColumn('eventTimestamp', 'Start Created', {
        dateFormat: "Y-m-d",
        mode: "single",
        allowInput: false,
        plugins: [new confirmDatePlugin({})]
    })
])
transactionSchema.join('stopTransaction', stopTransactionSchema);



const meterValueSchema = new JqlSchema([
    new TextColumn('id', 'Id'),
    new TextColumn('connectorId', 'Connector Id'),
    new TextColumn('transactionId', 'Transaction Id'),
    new TextColumn('value', 'Value'),
    new TextColumn('context', 'Context'),
    new TextColumn('format', 'Format'),
    new TextColumn('measurand', 'Measurand'),
    new TextColumn('phase', 'Phase'),
    new TextColumn('location', 'Location'),
    new TextColumn('unit', 'Unit'),
    new DateColumn('meterTimestamp', 'Meter Timestamp', {
        dateFormat: "Y-m-d",
        mode: "single",
        allowInput: false,
        plugins: [new confirmDatePlugin({})]
    })
])

const firmwareSchema = new JqlSchema([
    new TextColumn('id', 'Id'),
    new TextColumn('location', 'Location'),
    new NumberColumn('retries', 'Retries'),
    new NumberColumn('retryInterval', 'Retry Interval'),
    new DateColumn('retrieve', 'Retrieve', {
        dateFormat: "Y-m-d",
        mode: "single",
        allowInput: false,
        plugins: [new confirmDatePlugin({})]
    }),
    new DateColumn('created', 'Created', {
        dateFormat: "Y-m-d",
        mode: "single",
        allowInput: false,
        plugins: [new confirmDatePlugin({})]
    })
])

const diagnosticsSchema = new JqlSchema([
    new TextColumn('id', 'Id'),
    new TextColumn('location', 'Location'),
    new NumberColumn('retries', 'Retries'),
    new NumberColumn('retryInterval', 'Retry Interval'),
    new DateColumn('start', 'Start', {
        dateFormat: "Y-m-d",
        mode: "single",
        allowInput: false,
        plugins: [new confirmDatePlugin({})]
    }),
    new DateColumn('stop', 'Stop', {
        dateFormat: "Y-m-d",
        mode: "single",
        allowInput: false,
        plugins: [new confirmDatePlugin({})]
    }),
    new DateColumn('created', 'Created', {
        dateFormat: "Y-m-d",
        mode: "single",
        allowInput: false,
        plugins: [new confirmDatePlugin({})]
    })
])

const profileConnectorSchema = new JqlSchema([
    new TextColumn('id', 'Id'),
    new TextColumn('chargingProfilePk', 'Profile Id'),
    new TextColumn('chargeBoxId', 'Charge Box Id'),
    new TextColumn('connectorId', 'Connector Id'),
    new DateColumn('created', 'Created', {
        dateFormat: "Y-m-d",
        mode: "single",
        allowInput: false,
        plugins: [new confirmDatePlugin({})]
    })
])

// 충전 이용 현황 - 충전기별 상태
// 충전 이용 현황 - 충전전력/충전량
// 충전 이용 현황 - 시실간 충전전력/전압
// 충전 이용 현황 - 일별/시간별
// 충전 이용 현황 - 충전 이용률 현황
// 충전 이용 현황 - 충전 이용자 현황
// 충전 이용 현황 - 장애 발생 현황
// 충전 이용 현황 - 충전기별 예약 정보

class ExpPriceApi {
    constructor(url, schema) {
        this.baseUrl = url;
        this.schema = schema;
        this.columnInfos = schema.columns;
    }

    async requestExpectPrice(searchOptions) {
        const {priceId, acDcType, startTime, endTime} = searchOptions;
        const res = await http.get(this.baseUrl+`priceId=${priceId}&acDcType=${acDcType}&startTime=${startTime}&endTime=${endTime}`)

        return res;
    }
};

class aptChartApi {
    constructor(url) {
        this.baseUrl = url;
    }

    async requestChart(aptCode, year) {
        const res = await http.get(this.baseUrl+`/${aptCode}/${year}`);

        return res;
    }

    async requestInfo(aptCode, month) {
        const res = await http.get(this.baseUrl+`/percent/${aptCode}/${month}`);

        return res;
    }

    async requestChargeChart(aptCode, month) {
        const res = await http.get(this.baseUrl+`/info/${aptCode}/${month}`);

        return res;
    }
};

// 충전소 이용 현황  > 충전 이용 현황

const addrSchema = new JqlSchema([
    new NumberColumn('lat', '위도'),
    new NumberColumn('lng', '경도'),
    new TextColumn('region1depthName', '대분류'),
    new TextColumn('region2depthName', '중분류'),
    new TextColumn('region3depthName', '소분류'),
    new TextColumn('seq', 'seq'),
])

const evseUseSchema = new JqlSchema([
    new TextColumn('csId', 'CS ID'),
    new TextColumn('csoEvseNum', '충전기'),
    new TextColumn('capacity', '충전속도'),
    new TextColumn('speed', '속도'),
    new TextColumn('evseId', 'evse ID'),
    new TextColumn('connectorStatus', '충전상태'),
    new TextColumn('errorCode', '에러유형'),
    new TextColumn('vendorErrorCode', '제조사 에러'),
    new TextColumn('diffHour', '상태 지속시간'),
    new TextColumn('notiTime', '상태 확인시각'),
    new TextColumn('userCnt', '이용자수'),
    new Dropdown('station', '충전기 ID', {}),
    new Dropdown('failure', '에러 유형', {}),
])

placeSchema.join('addr', addrSchema);

class evseUseApi {
    constructor(url, schema) {
        this.baseUrl = url;
        this.schema = schema;
        this.columnInfos = schema.columns;
    }

    async requestEvseCount(placeId) {
        const res = await http.get(this.baseUrl+`/count/${placeId}`)

        return res.data;
    }

    async requestEvseStatus(placeId) {
        const res = await http.get(this.baseUrl+`/status/${placeId}`)

        return res.data;
    }

    async requestFailureByPlaceId(placeId, today) {
        const res = await http.get(this.baseUrl+`/failure/${placeId}/${today}`)

        return res.data;
    }

    async requestUserStat(placeId, csId, evseId, selectedDate) {
        const res = await http.get(this.baseUrl+`/user-stat/${placeId}/${csId}/${evseId}/${selectedDate}`)

        return res;
    }

    async requestChargeAmountChartByCsEvseId(placeId, csId, evseId, selectedDate) {
        const res = await http.get(this.baseUrl+`/meter/${placeId}/${csId}/${evseId}/${selectedDate}`)

        return res.data;
    }

    async requestChargingHistory(placeId, csId, evseId, selectedDate) {
        const res = await http.get(this.baseUrl+`/charging-hist/${placeId}/${csId}/${evseId}/${selectedDate}`)

        return res.data;
    }

    async requestFailureCountList(placeId, today) {
        const res = await http.get(this.baseUrl+`/failure-count/${placeId}/${today}`)

        return res.data;
    }

    async requestNoneUseCount(placeId, today) {
        const res = await http.get(this.baseUrl+`/none-use/${placeId}/${today}`)

        return res.data;
    }

    async requestLowCount(placeId, today) {
        const res = await http.get(this.baseUrl+`/current-low/${placeId}/${today}`)

        return res.data;
    }

    async requestFailureModalList(placeId, today) {
        const res = await http.post(this.baseUrl+`/failure-list/${placeId}/${today}`)

        return res.data;
    }

    async requestUtilChart(csId, evseId, selectedDate) {
        const res = await http.get(this.baseUrl+`/utilization/${csId}/${evseId}/${selectedDate}`)

        return res.data;
    }

    async requestUsedStatChart(placeId, targetDate) {
        const res = await http.get(this.baseUrl+`/used-stat-chart/${placeId}/${targetDate}`)

        return res.data;
    }
}



/***
 * Schema 간 Join 설정.
 */


// charging/percent/{aptCode}/{date}
export class RestService {
    constructor() {
        // api 추가 필요...
        this.mapAddress = new JqlApi(``, mapAddressSchema)
        this.station = new JqlApi(`/onmapi/place`, placeSchema)
        this.charger = new JqlApi(`/onmapi/evse`, chargerSchema)
        this.chargerLog = new JqlApi(`/onmapi/transaction`, transactionStateSchema)
        this.aptInfo = new JqlApi(`/onmapi/aptinfo`, aptInfoSchema)
        this.aptPowerInfo = new JqlApi(`/onmapi/aptpowerinfo`, aptPowerInfoSchema)
        this.aptUsedChart = new aptChartApi(`/onmapi/aptinfo/detail/used/chart`)
        this.aptPeakChart = new aptChartApi(`/onmapi/aptinfo/detail/peak/chart`)
        this.aptChargeChart = new aptChartApi(`/onmapi/aptinfo/detail/charging`)
        this.batch = new JqlApi(`/onmapi/manage/batch`, batchSchema)
        this.fee = new JqlApi(``, feeSchema)
        this.comPrice = new JqlApi(`/onmapi/chargingprice/company`, comPriceSchema)
        this.comPriceSeason = new JqlApi(`/onmapi/chargingpriceseason/company`, comPriceSeasonSchema)
        this.account = new JqlApi(`/onmapi/manage/account`, userSchema)
        this.notice = new JqlApi(`/onmapi/notice`, noticeSchema)
        this.expPrice = new ExpPriceApi(`/onmapi/charging-price/exp-price?`, expPriceSchema)
        this.chargerTodayChart = new ChargerToday(`/onmapi/utilization/chart`, chargerTodayChartSchema)
        this.chargerTodayResult = new ChargerToday(`/onmapi/utilization/result`, chargerTodayResultSchema)
        this.chargerEvseList = new ChargerToday(`/onmapi/utilization/evse/list`, chargerEvseListSchema)
        this.chargerEvseChart = new ChargerToday(`/onmapi/utilization/evse/chart`, chargerEvseChartSchema)
        this.chargerEvseResult = new ChargerToday(`/onmapi/utilization/evse/result`, chargerEvseResultSchema)
        this.chargerUser = new ChargerToday(`/onmapi/utilization/evse/user/result`, chargerEvseUserSchema)
        this.chargerStatus = new ChargerStatus(`/onmapi/utilization/devices/status`, chargerStatusSchema)

        // OCPP
        this.chargePoint = new JqlApi(`/onmapi/ocpp/charge-point`, chargePointSchema)
        this.idTag = new JqlApi(`/onmapi/ocpp/idtag`, idTagSchema)
        this.ocppLog = new JqlApi(`/onmapi/ocpp/log`, logSchema)
        this.connectorStatus = new JqlApi(`/onmapi/ocpp/connector-status`, connectorStatusSchema)
        this.reservation = new JqlApi(`/onmapi/ocpp/reservation`, reservationSchema)
        this.transaction = new JqlApi(`/onmapi/ocpp/transaction`, transactionSchema)
        this.chargingProfile = new JqlApi(`/onmapi/ocpp/profile`, profileSchema)
        this.profileConnector = new JqlApi(`/onmapi/ocpp/pfl-conn`, profileConnectorSchema)
        this.meterValues = new JqlApi(`/onmapi/ocpp/ocpp-meter-value`, meterValueSchema)
        this.firmware = new JqlApi(`/onmapi/ocpp/firmware`, firmwareSchema)
        this.diagnostics = new JqlApi(`/onmapi/ocpp/diagnostics`, diagnosticsSchema)

        // 충전소 이용현황
        this.evseUse = new evseUseApi(`/onmapi/evse`, evseUseSchema)
    }
}

